module.exports = __webpack_public_path__ + "img/ercode.dacf67ca.png";